import { render, staticRenderFns } from "./CustomerReportAlert.vue?vue&type=template&id=8dc13676"
import script from "./CustomerReportAlert.vue?vue&type=script&lang=js"
export * from "./CustomerReportAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports